import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { UserManager } from 'src/app/core/services/user-manager';
import { UserProfileFlagStore } from '../../store/user-profile-flag';

@Injectable({
  providedIn: 'root'
})
export class ProfileGuard {
  constructor(private router: Router, private userManager: UserManager) {}

  canMatch(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    let value = UserProfileFlagStore.getInstance().canActivateUserProfile;
    if (this.mapValore(value)) {
      return true;
    } else {
      this.router.navigate(['/']);
      return false;
    }
  }

  private mapValore(value: 'true' | 'false'): boolean {
    return value === 'true';
  }
}
